import React from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import NavigationLink from "./navigationLink";
import useNavigationData from "./useNavigationData";
import iconHelper from "../../utils/iconHelper";
import LinkButton from "../button/linkButton";
import FooterSection from "../footer/footerSection";

const FooterNavigation = () => {
  const data = useNavigationData();

  const footerNavigation = [];

  if (data.footerNavigation) {
    const nav = data.footerNavigation;

    if (nav) {
      nav.elements.elements.value.forEach((item, index) => {
        const overview = data?.primaryNavigation?.elements?.elements?.value[index];
        footerNavigation.push((
          <React.Fragment key={item.elements.title.value}>
            <Col lg={3}>
              <FooterSection
                sectionName={(
                  <>
                    <NavigationLink
                      href={overview.elements.url_slug.value}
                      key={overview.id}
                      className="nav-link p-0 no-style d-none d-lg-block"
                    >
                      {item.elements.title.value}
                    </NavigationLink>
                    <div className="d-lg-none">{item.elements.title.value}</div>
                  </>
                )}
              >
                <div className="nav">
                  {overview.elements.url_slug.value
                    && (
                      <NavigationLink
                        href={overview.elements.url_slug.value}
                        key={overview.id}
                        className="nav-link d-lg-none"
                      >
                        <FormattedMessage id="navigation.menu.overview" />
                      </NavigationLink>
                    )}
                  {item.elements.sub_items.value.map((link) => (
                    link.elements && <NavigationLink {...link} key={link.id} className="nav-link" />
                  ))}
                </div>
              </FooterSection>
            </Col>
          </React.Fragment>
        ));
      });

      if (nav.elements.elements.value.length < 3) {
        for (let i = nav.elements.elements.value.length; i <= 3; i += 1) {
          footerNavigation.push((
            <Col lg={3} />
          ));
        }
      }
    }

    if (data.secondaryNavigation) {
      const nextLine = nav.elements.elements.value.length > 3;
      footerNavigation.push((
        <React.Fragment key="menuinfonavigation1">
          <Col xs={12} lg={!nextLine ? 3 : undefined} className="footer-menu__quicklinks">
            <Row>
              {data.secondaryNavigation.elements.elements.value?.map((link) => {
                if (!link.id || !link.elements.icon) return null;

                return (
                  <Col
                    key={link.elements.title.value}
                    xs={12}
                    className={classNames(
                      "footer-section burger-navigation",
                      { "col-lg-auto": nextLine },
                    )}
                  >
                    <LinkButton
                      href={link.elements.external_url.value || `${link.elements.url_slug.value}`}
                      className="footer-section__header burger-navigation__nav-direct-link footer-menu__info--padding"
                      variant="normal"
                    >
                      {link.elements.icon.value.length > 0
                        && iconHelper(link.elements.icon.value[0].codename)}
                      {link.elements.title.value}
                    </LinkButton>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </React.Fragment>
      ));
    }
  }

  return footerNavigation;
};

export default FooterNavigation;
